import PlanList from './PlanList';

export default PlanList;
